import CONFIG from './config'

/**
 * 多租户公开站：URL 第一段是用户名（/jopus/…），没有或是保留字则视为根路径（站点列表页）。
 * 与服务端 users.ts 的 USERNAME_RE / RESERVED_USERNAMES 保持一致。
 */
const RESERVED = new Set([
    'admin', 'api', 'uploads', 'healthz', 'post', 'notes', 'activity', 'chat', '404', 'static', 'sites', 'u',
    'assets', 'manifest', 'favicon', 'robots', 'well-known', 'index', 'login', 'logout', 'settings',
])
const USERNAME_RE = /^[a-z0-9][a-z0-9_-]{1,31}$/i

let tenant

/** 当前站点的用户名；根路径返回 null。整个页面生命周期内不变（换用户是整页导航） */
export const getTenant = () => {
    if (tenant !== undefined) return tenant
    const seg = (window.location.pathname.split('/')[1] || '')
    tenant = USERNAME_RE.test(seg) && !RESERVED.has(seg.toLowerCase()) ? seg : null
    return tenant
}

/** react-router basename：/<username> */
export const basename = () => '/' + (getTenant() || '')

/** 该站点的公开 API 前缀：<apiBase>/api/u/<username> */
export const apiPrefix = () => (CONFIG.apiBase || '') + '/api/u/' + getTenant()

/** 对外分享用的绝对地址（带用户名前缀） */
export const publicUrl = (path) => window.location.origin + basename() + path

// 七牛 CDN 根地址（https://cdn.xxx，随目录 site.cdnBase 下发）：上传图片的原件可能只在七牛，直接拼 CDN 地址省掉源站 302 一跳
let cdnBase = ''
export function setCdnBase(base) {
    cdnBase = typeof base === 'string' && /^https:\/\//.test(base) ? base.replace(/\/+$/, '') : ''
}

/** 卡片正文里的图片 src → 加载地址：/uploads/… 有 CDN 走 CDN，其它原样（外链图不动） */
export function mediaUrl(src) {
    if (!src || !cdnBase || !src.startsWith('/uploads/')) return src
    return cdnBase + src
}

/** 站内相对资源（如站点设置里的 /uploads/… logo）→ 可加载地址：/uploads 有 CDN 走 CDN；否则生产同域原样返回，dev 分域时带上 apiBase */
export function assetUrl(u) {
    if (!u) return u
    if (cdnBase && u.startsWith('/uploads/')) return cdnBase + u
    return u.startsWith('/') ? (CONFIG.apiBase || '') + u : u
}
